import { createAction, props } from '@ngrx/store';
import { Lookup } from 'src/app/shared/models/lookup.model';
import { HierarchicalOption } from '../../../shared/models/hierarchical-option.model';
import { CountryState } from '../../../shared/models/lookup-country-states.model';

export const lookupAccountManagers = createAction(
    '[WORKFORCE SOLUTIONS COMPONENT] Load Account Managers Lookups',
    props<{ filterText: string }>()
);

export const lookupAccountManagersSuccess = createAction(
    '[HOSPITAL SERVICE API] Load Account Managers Lookups Success',
    props<{ accountManagers: Lookup[] }>()
);

export const lookupAccountManagersFailure = createAction(
    '[HOSPITAL SERVICE API] Load Account Managers Lookups Fail',
    props<{ error: string }>()
);
//---------------------------------------------------------------------------------------------------------------------
export const lookupVMSProviders = createAction(
    '[WORKFORCE SOLUTIONS  COMPONENT] Load VMS Providers Lookups',
    props<{ filterText: string }>()
);

export const lookupVMSProvidersSuccess = createAction(
    '[HOSPITAL SERVICE API] Load VMS Providers Lookups Success',
    props<{ vmsProviders: Lookup[] }>()
);

export const lookupVMSProvidersFailure = createAction(
    '[HOSPITAL SERVICE API] Load VMS Providers Lookups Fail',
    props<{ error: string }>()
);
//---------------------------------------------------------------------------------------------------------------------
export const lookupHospitalSystems = createAction(
    '[WORKFORCE SOLUTIONS  COMPONENT] Load Hospital Systems Lookups',
    props<{ filterText: string }>()
);

export const lookupHospitalSystemsSuccess = createAction(
    '[HOSPITAL SERVICE API] Load Hospital Systems Lookups Success',
    props<{ hospitalSystems: Lookup[] }>()
);

export const lookupHospitalSystemsFailure = createAction(
    '[HOSPITAL SERVICE API] Load Hospital Systems Lookups Fail',
    props<{ error: string }>()
);
//---------------------------------------------------------------------------------------------------------------------
export const lookupHospitalSystemsHierarchy = createAction(
    '[WORKFORCE SOLUTIONS  COMPONENT] Load Hospital Systems Hierarchy Lookups'
);

export const lookupHospitalSystemsHierarchySuccess = createAction(
    '[HOSPITAL SERVICE API] Load Hospital Systems Hierarchy Lookups Success',
    props<{ hospitalSystemsHierarchy: HierarchicalOption[] }>()
);

export const lookupHospitalSystemsHierarchyFailure = createAction(
    '[HOSPITAL SERVICE API] Load Hospital Systems Hierarchy Lookups Fail',
    props<{ error: string }>()
);
//---------------------------------------------------------------------------------------------------------------------
export const lookupContractedGroups = createAction(
    '[WORKFORCE SOLUTIONS  COMPONENT] Load Contracted Groups Lookups',
    props<{ filterText: string }>()
);

export const lookupContractedGroupsSuccess = createAction(
    '[HOSPITAL SERVICE API] Load Contracted Groups Lookups Success',
    props<{ contractedGroups: Lookup[] }>()
);

export const lookupContractedGroupsFailure = createAction(
    '[HOSPITAL SERVICE API] Load Contracted Groups Lookups Fail',
    props<{ error: string }>()
);
//---------------------------------------------------------------------------------------------------------------------
export const lookupBrands = createAction('[WORKFORCE SOLUTIONS  COMPONENT] Load Brands Lookups');

export const lookupBrandsSuccess = createAction(
    '[HOSPITAL SERVICE API] Load Brands Lookups Success',
    props<{ brands: Lookup[] }>()
);

export const lookupBrandsFailure = createAction(
    '[HOSPITAL SERVICE API] Load Brands Lookups Fail',
    props<{ error: string }>()
);
//---------------------------------------------------------------------------------------------------------------------
export const lookupBizDevManagers = createAction(
    '[WORKFORCE SOLUTIONS  COMPONENT] Load Biz DEV Managers Lookups',
    props<{ filterText: string }>()
);

export const lookupBizDevManagersSuccess = createAction(
    '[HOSPITAL SERVICE API] Load Biz DEV Managers Lookups Success',
    props<{ bizDevManagers: Lookup[] }>()
);

export const lookupBizDevManagersFailure = createAction(
    '[HOSPITAL SERVICE API] Load Biz DEV Managers Lookups Fail',
    props<{ error: string }>()
);
//---------------------------------------------------------------------------------------------------------------------
export const lookupMSPManagers = createAction(
    '[WORKFORCE SOLUTIONS  COMPONENT] Load MSP Managers Lookups',
    props<{ filterText: string }>()
);

export const lookupMSPManagersSuccess = createAction(
    '[HOSPITAL SERVICE API] Load MSP Managers Lookups Success',
    props<{ mspManagers: Lookup[] }>()
);

export const lookupMSPManagersFailure = createAction(
    '[HOSPITAL SERVICE API] Load MSP Managers Lookups Fail',
    props<{ error: string }>()
);
//---------------------------------------------------------------------------------------------------------------------
export const lookupFacilityTypes = createAction('[WORKFORCE SOLUTIONS  COMPONENT] Load Facility Types Lookups');

export const lookupFacilityTypesSuccess = createAction(
    '[HOSPITAL SERVICE API] Load Facility Types Lookups Success',
    props<{ facilityTypes: Lookup[] }>()
);

export const lookupFacilityTypesFailure = createAction(
    '[HOSPITAL SERVICE API] Load FacilityTypes Lookups Fail',
    props<{ error: string }>()
);
//---------------------------------------------------------------------------------------------------------------------
export const lookupStates = createAction('[WORKFORCE SOLUTIONS  COMPONENT] Load States Lookups');

export const lookupStatesSuccess = createAction(
    '[HOSPITAL SERVICE API] Load States Lookups Success',
    props<{ states: CountryState[] }>()
);

export const lookupStatesFailure = createAction(
    '[HOSPITAL SERVICE API] Load States Lookups Fail',
    props<{ error: string }>()
);
